import { useEffect } from 'react';

import {
  AppraisalsRoutePaths,
  useStartGuestAppraisalMutation,
} from '@app-velocity/modules/appraisals';

import { useCreateGuestProjectMutation } from '@app-velocity/modules/projects';

import { NewReviewContext } from '../context/NewReviewContext';
import { NewReview } from '../NewReview';

import { NewReviewSkeleton } from '../components/NewReviewSkeleton';

export const NewGuestReview = () => {
  const { mutate: createGuestProject, data: guestWorkspace } =
    useCreateGuestProjectMutation();

  const { mutateAsync: startAppraisal } = useStartGuestAppraisalMutation(
    guestWorkspace?.id
  );

  useEffect(() => {
    createGuestProject({
      name: 'My Workspace',
    });
  }, []);

  if (!guestWorkspace) return <NewReviewSkeleton />;

  return (
    <NewReviewContext.Provider
      value={{
        mode: 'guest',
        workspaceId: guestWorkspace.id,
        teamId: '',
        onReviewStart: startAppraisal,
        goToAppraisalDetails: AppraisalsRoutePaths.guestAppraisalDetails,
      }}
    >
      <NewReview />
    </NewReviewContext.Provider>
  );
};
